/**
 * 서버가 필터로 걸러낸 뒤 빈 페이지를 돌려주는 경우가 있어, 내용이 찰 때까지 커서를 몇 번 더 따라간다.
 * 상한이 없으면 큰 목록에서 요청이 끝없이 이어질 수 있어 3번에서 멈춘다(경험적 초기값).
 */
const MAX_EMPTY_CURSOR_CONTINUATIONS = 3;

interface CursorPageResponse {
  data: unknown[];
  hasNext: boolean;
  nextCursor?: string;
  totalCount?: number;
}

/**
 * 커서 한 페이지를 읽는다. 빈 페이지면 다음 커서로 이어 받는다.
 *
 * `totalCount` 는 첫 응답 값을 보존한다 — 이어 받은 응답이 비워 보내도 개수 표시가 흔들리지 않게.
 */
export const followEmptyCursorPages = async <R extends CursorPageResponse>(
  fetchPage: (cursor?: string) => Promise<R>,
  cursor?: string,
): Promise<R> => {
  let response = await fetchPage(cursor);
  const initialTotalCount = response.totalCount;

  for (
    let skippedCount = 0;
    skippedCount < MAX_EMPTY_CURSOR_CONTINUATIONS;
    skippedCount += 1
  ) {
    if (response.data.length > 0 || !response.hasNext || !response.nextCursor) {
      break;
    }
    response = await fetchPage(response.nextCursor);
  }

  return { ...response, totalCount: response.totalCount ?? initialTotalCount };
};
